module.exports = __webpack_public_path__ + "media/images/icon/white/ico_question-3a1a8557508b6283255bf3cb197b1aee.svg";